import React, { useState } from "react";

const MobileLoginTest = () => {
  const [testResults, setTestResults] = useState({});
  const [isRunning, setIsRunning] = useState(false);

  const runTests = async () => {
    setIsRunning(true);
    const results = {};

    // Test 1: LocalStorage
    try {
      localStorage.setItem("test", "value");
      localStorage.removeItem("test");
      results.localStorage = "✅ Working";
    } catch (e) {
      results.localStorage = "❌ Failed: " + e.message;
    }

    // Test 2: Fetch API
    try {
      const manifestUrl = `${window.location.origin}/manifest.json`;
      const response = await fetch(manifestUrl, {
        method: "HEAD",
      });
      results.fetchAPI = response.ok
        ? "✅ Working"
        : "❌ Failed: " + response.status;
    } catch (e) {
      results.fetchAPI = "❌ Failed: " + e.message;
    }

    // Test 3: Form submission
    try {
      const form = document.createElement("form");
      form.style.display = "none";
      document.body.appendChild(form);
      results.formSubmission = "✅ Forms supported";
      document.body.removeChild(form);
    } catch (e) {
      results.formSubmission = "❌ Failed: " + e.message;
    }

    // Test 4: Touch events
    results.touchEvents =
      "ontouchstart" in window ? "✅ Touch supported" : "❌ No touch support";

    // Test 5: Viewport
    results.viewport = `${window.innerWidth}x${window.innerHeight} (${window.devicePixelRatio}x DPR)`;

    // Test 6: User agent
    results.userAgent = navigator.userAgent.includes("Mobile")
      ? "✅ Mobile detected"
      : "⚠️ Desktop detected";

    // Test 7: Connection
    if (navigator.connection) {
      results.connection = `✅ ${navigator.connection.effectiveType} (${navigator.connection.downlink}Mbps)`;
    } else {
      results.connection = "⚠️ Connection API not available";
    }

    // Test 8: CORS and API endpoint
    try {
      // Use UrbanPOS API for all environments
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.urbanpos.com/api";

      console.log("Testing API URL:", apiUrl);
      results.apiUrl = `Testing: ${apiUrl}`;

      const response = await fetch(`${apiUrl}/health`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      results.apiConnection = response.ok
        ? "✅ API reachable"
        : "❌ API error: " + response.status;
    } catch (e) {
      // Use UrbanPOS API for all environments
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.urbanpos.com/api";
      results.apiConnection = "❌ API failed: " + e.message;
      results.apiUrl = `Failed: ${apiUrl}`;
    }

    setTestResults(results);
    setIsRunning(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 p-4">
      <div className="max-w-md mx-auto bg-gray-800 rounded-lg p-6">
        <h1 className="text-white text-xl font-bold mb-4">
          Mobile Login Diagnostic
        </h1>

        <button
          onClick={runTests}
          disabled={isRunning}
          className="w-full bg-blue-600 text-white py-3 rounded-lg mb-6 disabled:opacity-50"
        >
          {isRunning ? "Running Tests..." : "Run Diagnostic Tests"}
        </button>

        {Object.keys(testResults).length > 0 && (
          <div className="space-y-3">
            <h2 className="text-white font-semibold">Test Results:</h2>
            {Object.entries(testResults).map(([test, result]) => (
              <div key={test} className="bg-gray-700 p-3 rounded">
                <div className="text-gray-300 text-sm font-medium">{test}:</div>
                <div className="text-white text-sm">{result}</div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-6 p-4 bg-gray-700 rounded">
          <h3 className="text-white font-semibold mb-2">Quick Device Info:</h3>
          <div className="text-gray-300 text-sm space-y-1">
            <div>
              Screen: {window.screen.width}×{window.screen.height}
            </div>
            <div>
              Viewport: {window.innerWidth}×{window.innerHeight}
            </div>
            <div>Pixel Ratio: {window.devicePixelRatio}</div>
            <div>Platform: {navigator.platform}</div>
            <div>Language: {navigator.language}</div>
            <div>Online: {navigator.onLine ? "Yes" : "No"}</div>
            <div>Cookies: {navigator.cookieEnabled ? "Yes" : "No"}</div>
          </div>
        </div>

        <div className="mt-4 text-center">
          <a
            href="/login"
            className="text-blue-400 hover:text-blue-300 text-sm"
          >
            ← Back to Login
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileLoginTest;
